import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { EmbeddedHost } from '../shared/embedded-host.js';
import './sdb-composition-player.js';

@customElement('sdb-embedded-composition-player')
class SdbEmbeddedCompositionPlayer extends EmbeddedHost(LitElement) {

    @property({ type: String })
    accessor sessionId;

    @property({ type: String })
    accessor type = 'composition';

    @property({ type: Boolean })
    accessor preview = false;

    @property({ type: Boolean })
    accessor hideCompositionStatus = false;

    isReady(state) {
        return super.isReady(state) && !!this.compositionId;
    }

    environmentPayload() {
        return { ...super.environmentPayload(), preview: this.preview };
    }

    render() {
        if (!this.ready) {
            return nothing;
        }

        return html`
            <sdb-composition-player
                compositionId=${this.compositionId}
                sessionId=${this.sessionId}
                type=${this.type}
                ?preview=${this.preview}
                ?hideCompositionStatus=${this.hideCompositionStatus}>
            </sdb-composition-player>
        `;
    }
}
